// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ATH4","title":"Info_title__3Qpd1","links":"Info_links__3peuK","link":"Info_link__3TOeZ","logo":"Info_logo__21F62"};